"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _TransferHistory = _interopRequireDefault(require("../../components/Settings/TransferHistory"));
require("./UserContactsLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var userContactsLayoutClasses = (0, _cssClassesHelper.getBEMClasses)('user-contacts-layout');
var UserContactsLayout = function UserContactsLayout() {
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: userContactsLayoutClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: userContactsLayoutClasses('block-with-text')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: userContactsLayoutClasses('header-text')
  }, t('Trading with Other On-Exchange Participants')), /*#__PURE__*/_react["default"].createElement("div", {
    className: userContactsLayoutClasses('text')
  }, t('You can freely transfer currency with other participants on the exchange. Simply provide the email address for your contact during the Send or Receive process. If the email address is registered on the exchange, then the user will receive the transfer. If the email address is not registered, the user will get an invitation to join the exchange.'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: userContactsLayoutClasses('transfer')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: userContactsLayoutClasses('transfer-header')
  }, t('Transfer History')), /*#__PURE__*/_react["default"].createElement("div", {
    className: userContactsLayoutClasses('transfer-items')
  }, /*#__PURE__*/_react["default"].createElement(_TransferHistory["default"], null))));
};
var _default = exports["default"] = UserContactsLayout;